import * as React from 'react';
import { AppComponentProps } from '../../typescriptHelpers';
import ReleasePilotRotationTable from './ReleasePilotRotationTable';
import Space from 'antd/lib/space';

const ReleasePilotRotationComponent: React.FC<AppComponentProps> = (props: AppComponentProps) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Space direction="vertical" size={40}>
                <ReleasePilotRotationTable {...props} />
            </Space>
        </div>
    );
};

export default ReleasePilotRotationComponent;
